if ( typeof ProductPage !== 'function' ) {

	const itgFreeGiftLabel = document.body ? document.body.getAttribute('data-free-gift-label') : '';

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.initialVariantMediaSyncAttempts = 0;
			this.initialVariantMediaSyncLimit = 10;
			this.initialVariantMediaSyncDelay = 50;
			this.initialVariantMediaSyncTimeout = null;
			this.productGallerySlides = [];
			this.productGalleryFigures = [];
			this.onVariantChangeListener = this.onVariantChangeHandler.bind(this);

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');
			this.enableGalleryParallax = !this.classList.contains('product-quick-view__product');
			this.onLiveOptionsInteraction = this.restoreLiveOptionsGalleryPreviews.bind(this);

			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							this.syncThumbnailPreviewToGallerySlide(e.currentTarget.dataset.index, e.currentTarget);
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('change', e=>{
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', ()=>{
					this.refreshProductGalleryMediaCache();
					
					if ( this.firstProductGalleryIndex ) {
						this.moveProductGalleryToIndex(this.firstProductGalleryIndex, 'auto');
					}

					if ( this.enableGalleryParallax ) {
						this.productSlider.addEventListener('scroll', ()=>{
							this.syncProductGalleryParallax();
						});
						this.syncProductGalleryParallax();
					} else {
						this.resetProductGalleryParallax();
					}

				});

			}

			this.addEventListener('change', this.onLiveOptionsInteraction, true);
			this.addEventListener('input', this.onLiveOptionsInteraction, true);

			// show cart drawer when product is added to cart

			// cart update progress bar

			function updateCartProgress() {


				let storedCartPrice = parseFloat(localStorage.getItem('loadedCartPrice')) || 0;

						console.log('Stored cart price from localStorage:', storedCartPrice);

						console.log("Cart successfully updated");

						const subTotalElem = document.getElementById('AjaxCartSubtotal');
						if (!subTotalElem) return;

						let subTotalAmt = subTotalElem.querySelector('.cart__total')?.getAttribute("data-total-price");
						if (!subTotalAmt) return;
					
						let cartPrice = parseFloat(subTotalAmt.replace(/,/g, '').trim());
						console.log(isNaN(cartPrice), "cartPrice", cartPrice);

						const mainProgressWrapper = document.querySelector('.cart_drawer_progress_bar_inner_wrapper');
						if (!mainProgressWrapper) return;

						const cartBar = mainProgressWrapper.querySelector(".cart_drawer_progress_bar");
						if (!cartBar) return;

						console.log(subTotalAmt);

						const maxAmountPrice = parseFloat(cartBar.getAttribute("data-maxamt"));
						if (isNaN(maxAmountPrice) || maxAmountPrice <= 0) return;

						(async () => {
							// Fetch current cart
							const cartResponse = await fetch('/cart.js');
							const cart = await cartResponse.json();

							let allProductsHTML = '';

							const mainProgressWrapper = document.querySelector('.cart_drawer_progress_bar_inner_wrapper');
							if (!mainProgressWrapper) return;

							const cartBar = mainProgressWrapper.querySelector(".cart_drawer_progress_bar");
							if (!cartBar) return;

							const maxAmountPrice = parseFloat(cartBar.getAttribute("data-maxamt"));
							const subTotalElem = document.getElementById('AjaxCartSubtotal')?.querySelector('.cart__total');
							const cartPrice = parseFloat(subTotalElem?.getAttribute("data-total-price")?.replace(/,/g, '').trim() || 0);

							const allSteps = mainProgressWrapper.querySelectorAll(".progbar_counter");
							if (!allSteps.length) return;
						
							// allSteps.forEach((step, index) => {
							// 	const stepAmount = parseFloat(step.getAttribute("data-amount"));
							// 	if (isNaN(stepAmount) || maxAmountPrice <= 0) return;

							// 	step.style.left = Math.round((stepAmount / maxAmountPrice) * 100) + "%";

							// 	const productElem = step.querySelector(".product_or_discount");
							// 	if (!productElem) return;

							// 	const type = productElem.getAttribute("data-product-or-discount");
							// 	const productVariantId = productElem.getAttribute("data-product-id");
							// 	const wrapperId = `cart_drawer_free_product_wrapper_step_${index}`;

							// 	// -----------------------------
							// 	// IF (cartPrice >= stepAmount)
							// 	// -----------------------------
							// 	if (cartPrice >= stepAmount && type === "product") {

							// 		const hasFreeItem = cart.items.some(item => {
							// 			const id = item.id.toString().replace("item-", "");
							// 			return id === productVariantId.toString() && Number(item.price) === 0;
							// 		});

							// 		const hasPaidItem = cart.items.some(item => {
							// 			const id = item.id.toString().replace("item-", "");
							// 			return id === productVariantId.toString() && Number(item.price) > 0;
							// 		});

							// 		console.log(hasFreeItem, "hasFreeItem (price=0)");
							// 		console.log(hasPaidItem, "hasPaidItem (price>0)");

							// 		// Rule: DO NOT render if a free version already exists
							// 		const shouldRender = !hasFreeItem;

							// 		if (shouldRender) {
							// 			allProductsHTML += `
							// 				<div class="single_step_product_wrapper" id="${wrapperId}">
							// 					<div class="free_product_wrapper_inner">
							// 						${productElem.innerHTML}
							// 					</div>
							// 				</div>`;
							// 		}
							// 	}

							// 	// -----------------------------
							// 	// ELSE (cartPrice < stepAmount)
							// 	// -----------------------------
							// 	else {

							// 		// 1. Remove accordion
							// 		const mainAccordion = document.querySelector('.main_free_product_accordion_wrapper');
							// 		if (mainAccordion) {
							// 			const productWrapper = mainAccordion.querySelector(`#${wrapperId}`);
							// 			if (productWrapper) productWrapper.remove();
							// 		}

							// 		// 2. Remove ONLY free version from cart
							// 		if (type === "product") {

							// 			// Find all matched items
							// 			const matchedItems = cart.items.filter(item => {
							// 				const id = item.id.toString().replace("item-", "");
							// 				return id === productVariantId.toString();
							// 			});

							// 			console.log(matchedItems , "matchedItems in else part") ;

							// 			matchedItems.forEach(item => {

							// 				console.log(item.price , "each item Price in else");
											
							// 				const price = Number(item.price);
							// 				if (price === 0) {
							// 					console.log("Removing free item:", item.id);
							// 					removeProductFromCart(productVariantId);
							// 				} else {
							// 					console.log("Keeping paid item:", item.id);
							// 				}
							// 			});
							// 		}
							// 	}
							// });

							allSteps.forEach((step, index) => {
								const stepAmount = parseFloat(step.getAttribute("data-amount"));
								if (isNaN(stepAmount) || maxAmountPrice <= 0) return;

								step.style.left = Math.round((stepAmount / maxAmountPrice) * 100) + "%";

								const productElem = step.querySelector(".product_or_discount");
								if (!productElem) return;

								const type = productElem.getAttribute("data-product-or-discount");
								const productVariantId = productElem.getAttribute("data-product-id");
								const wrapperId = `cart_drawer_free_product_wrapper_step_${index}`;

                                const productIdOnly = productElem.querySelector('.cart_free_product_wrapper')?.getAttribute("data-product-id");

                                // -----------------------------
                                // IF (cartPrice >= stepAmount)
                                // -----------------------------

                                if (cartPrice >= stepAmount && type === "product") {

                                    // Check ANY variant of the same product
                                    const hasFreeItem = cart.items.some(item => {
                                        console.log(item.product_id , "item.product_id" );
                                        console.log(productVariantId , "Product-variant_id" );
                                        console.log(productIdOnly , "Product_id" );
                                        return item.product_id.toString() === productIdOnly.toString() && Number(item.price) === 0;
                                    });

                                    const hasPaidItem = cart.items.some(item => {
                                        console.log(item.product_id , "item.product_id" );
                                        console.log(productVariantId , "Product-variant_id" );
                                        console.log(productIdOnly , "Product_id" );
                                        return item.product_id.toString() === productIdOnly.toString() && Number(item.price) > 0;
                                    });

                                    console.log(hasFreeItem, "hasFreeItem (price=0)");
                                    console.log(hasPaidItem, "hasPaidItem (price>0)");

                                    // If ANY variant exists → do NOT render
                                    // const shouldRender = !hasFreeItem && !hasPaidItem;
                                    const shouldRender = !hasFreeItem;

                                    if (shouldRender) {
                                        allProductsHTML += `
                                            <div class="single_step_product_wrapper" id="${wrapperId}">
                                                <div class="free_product_wrapper_inner">
                                                    ${productElem.innerHTML}
                                                </div>
                                            </div>`;
                                    }
                                }


                                else {

                                        // 1. Remove accordion HTML
                                        const mainAccordion = document.querySelector('.main_free_product_accordion_wrapper');
                                        if (mainAccordion) {
                                            const productWrapper = mainAccordion.querySelector(`#${wrapperId}`);
                                            if (productWrapper) productWrapper.remove();
                                        }

                                        // 2. Remove only free variant from cart
                                        if (type === "product") {

                                            const matchedItems = cart.items.filter(item => {
                                                return item.product_id.toString() === productIdOnly.toString();
                                            });
                                            

                                            matchedItems.forEach(item => {
                                                if (Number(item.price) === 0) {
                                                    console.log("Removing free item:", item.variant_id);
                                                    // by line key when available: the variant-id remove link can hit a paid line of the same variant
                                                    if (typeof window.itgRemoveFreeGiftLine === 'function' && item.key) {
                                                        window.itgRemoveFreeGiftLine(item);
                                                    } else {
                                                        removeProductFromCart(item.variant_id);
                                                    }
                                                } else {
                                                    console.log("Keeping paid variant:", item.variant_id);
                                                }
                                            });
                                        }
                                    }

                                });

							let sidebarWrapper = document.querySelector('.sidebar__free_product_wrapper');

							let cartPageWrapper = document.querySelector('.cart-form__items .sidebar__free_product_wrapper');

							if (!cartPageWrapper && document.body.classList.contains('template-cart')) {
								const cartItemsWrapper = document.querySelector('.cart-form__items');
								if (cartItemsWrapper) {
									cartPageWrapper = document.createElement('div');
									cartPageWrapper.classList.add('sidebar__free_product_wrapper');
									cartItemsWrapper.appendChild(cartPageWrapper);

										if (allProductsHTML.trim() !== '') {
											const wrapper = document.createElement('div');
											wrapper.classList.add('main_free_product_accordion_wrapper');
											wrapper.innerHTML = `
												<div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
													<span class="productTitleItg">${itgFreeGiftLabel}</span>
													<span class="svg-wrapper accordion_down_icon">
														<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
															<path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
														</svg>
													</span>
												</div>
												<div class="free_product_wrapper" style="display:block;">
													<div class="free_product_inner_container">
														${allProductsHTML}
													</div>
												</div>
											`;

											// Toggle accordion
											wrapper.querySelector('.headerItg').addEventListener('click', () => {
												const content = wrapper.querySelector('.free_product_wrapper');
												content.style.display = content.style.display === 'block' ? 'none' : 'block';
											});

											cartPageWrapper.appendChild(wrapper);
										} else {
											cartPageWrapper.classList.add('hideWrapper');
										}
									
									}
								}else{
									let sidebarWrapper = document.querySelector('.cart-form__items .sidebar__free_product_wrapper');
									if (sidebarWrapper) {
										sidebarWrapper.innerHTML = '';
									}
								}       


							// CART DRAWER: clear previous content
							if (sidebarWrapper) {
								sidebarWrapper.innerHTML = '';
							}

						
							// Only build accordion if there are products
							if (allProductsHTML.trim() !== '') {
								const wrapper = document.createElement('div');
								wrapper.classList.add('main_free_product_accordion_wrapper');
								wrapper.innerHTML = `
									<div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
										<span class="productTitleItg">${itgFreeGiftLabel}</span>
										<span class="svg-wrapper accordion_down_icon">
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
												<path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
											</svg>
										</span>
									</div>
									<div class="free_product_wrapper" style="display:block;">
										<div class="free_product_inner_container">
											${allProductsHTML}
										</div>
									</div>
								`;

								// Toggle accordion
								wrapper.querySelector('.headerItg').addEventListener('click', () => {
									const content = wrapper.querySelector('.free_product_wrapper');
									content.style.display = content.style.display === 'block' ? 'none' : 'block';
								});

								sidebarWrapper.classList.remove('hideWrapper');
								sidebarWrapper.appendChild(wrapper);
							} else {
								sidebarWrapper.classList.add('hideWrapper');
							}
						})();



						// Filled bar
						if (!isNaN(cartPrice)) {
							let filledPercent = ((cartPrice * 100) / maxAmountPrice);
							filledPercent = Math.min(Math.max(filledPercent, 0), 100);

							const filledBar = cartBar.querySelector(".cart_drawer_filled_bar");
							if (filledBar) {
								filledBar.style.width = filledPercent + "%";

							}
						
						}

						// subtotalAmt Updated

						console.log(subTotalAmt);

						document.querySelector('.cart_drawer_progress_bar').setAttribute("data-cart-price" , subTotalAmt ) ;
						localStorage.setItem('loadedCartPrice', subTotalAmt);


					// removeProductFromCart  function //

					async function removeProductFromCart(productVariantId) {
						try {
							const lineItemElem = document.querySelector(`#item-${productVariantId}`);

							if (lineItemElem) {
								const removeBtn = lineItemElem.querySelector('a.remove, button.remove');

								if (removeBtn) {
									removeBtn.click(); // trigger click on the remove button
									console.log(`Clicked remove for variant ${productVariantId}`);


								} else {
									console.warn(`Remove button not found for variant ${productVariantId}`);
								}
							} else {
								console.warn(`Line item not found in DOM for variant ${productVariantId}`);
							}
						} catch (err) {
							console.error(`Error removing variant ${productVariantId}:`, err);
						}
					}	


			}


			// cart update progress bar

			if ( ! document.body.classList.contains('template-cart') && ( KROWN.settings.cart_action == 'overlay' || KROWN.settings.cart_action == 'popup' ) ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
							window.lastFocusedElm = this.querySelector('[data-js-product-add-to-cart]');

							updateCartProgress();
							console.log("cart updated successfully");
							
							// cartProgress Function
							
						}
						console.log("add to cart Clicked");

					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
								addToCartEnter = false;
							}, 200);
						}

						updateCartProgress();
						console.log("cart updated successfully");
						// cartProgress Function

						console.log("add to cart Clicked");
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}


			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeListener);
				this.syncInitialVariantMedia();
			}

		}

		disconnectedCallback(){
			if ( this.initialVariantMediaSyncTimeout ) {
				clearTimeout(this.initialVariantMediaSyncTimeout);
				this.initialVariantMediaSyncTimeout = null;
			}

			this.removeEventListener('change', this.onLiveOptionsInteraction, true);
			this.removeEventListener('input', this.onLiveOptionsInteraction, true);

			if ( this.productVariants && this.onVariantChangeListener ) {
				this.productVariants.removeEventListener('VARIANT_CHANGE', this.onVariantChangeListener);
			}
		}

		refreshProductGalleryMediaCache(){
			if ( ! this.productSlider ) {
				this.productGallerySlides = [];
				this.productGalleryFigures = [];
				return;
			}

			this.productGallerySlides = [...this.productSlider.querySelectorAll('.product-gallery-item')];
			this.productGalleryFigures = [...this.querySelectorAll('.apply-gallery-animation')];
		}

		syncInitialVariantMedia(){
			if ( ! this.productVariants ) {
				return;
			}

			if ( this.productVariants.currentVariant ) {
				this.initialVariantMediaSyncAttempts = 0;
				this.onVariantChangeHandler({target:this.productVariants});
				return;
			}

			if ( this.initialVariantMediaSyncAttempts >= this.initialVariantMediaSyncLimit ) {
				return;
			}

			this.initialVariantMediaSyncAttempts += 1;
			this.initialVariantMediaSyncTimeout = setTimeout(()=>{
				this.initialVariantMediaSyncTimeout = null;
				this.syncInitialVariantMedia();
			}, this.initialVariantMediaSyncDelay);
		}

		syncProductGalleryParallax(){
			if ( ! this.enableGalleryParallax ) {
				return;
			}

			if ( ! this.productSlider || ! this.productSlider.element ) {
				return;
			}

			if ( this.productGallerySlides.length === 0 ) {
				this.refreshProductGalleryMediaCache();
			}

			const scrollX = -this.productSlider.element.scrollLeft;

			this.productGallerySlides.forEach((slide,i)=>{
				const media = this.productGalleryFigures[i];
				if ( media ) {
					media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
				}
			});
		}

		resetProductGalleryParallax(){
			if ( this.productGalleryFigures.length === 0 ) {
				this.refreshProductGalleryMediaCache();
			}

			this.productGalleryFigures.forEach((media)=>{
				media.style.removeProperty('transform');
			});
		}

		moveProductGalleryToIndex(index, behavior='auto'){
			const normalizedIndex = String(index);
			this.refreshProductGalleryMediaCache();

			if ( ! this.productSlider || ! this.productSlider.sliderEnabled || typeof this.productSlider.changeSlide !== 'function' ) {
				return false;
			}

			this.productSlider.changeSlide(normalizedIndex, behavior);
			this.syncProductGalleryParallax();

			return true;
		}

		normalizeGalleryPreviewFilename(src){
			if ( ! src ) {
				return null;
			}

			try {
				const resolved = new URL(src, window.location.origin);
				const parts = resolved.pathname.split('/');
				const filename = parts[parts.length - 1];
				if ( ! filename ) {
					return null;
				}

				return filename.replace(/_(?:\d+x\d+|\d+x)(?=\.[a-z0-9]+)/i, '').toLowerCase();
			} catch (_error) {
				return null;
			}
		}

		buildMainPreviewSrc(src){
			if ( ! src ) {
				return null;
			}

			try {
				const resolved = new URL(src, window.location.origin);
				resolved.searchParams.delete('width');
				resolved.searchParams.delete('height');
				resolved.searchParams.delete('crop');
				return resolved.toString();
			} catch (_error) {
				return null;
			}
		}

		getComparableGalleryImageSrc(image){
			if ( ! image ) {
				return null;
			}

			return image.currentSrc
				|| image.getAttribute('src')
				|| image.getAttribute('data-src')
				|| ( image.getAttribute('srcset') || '' ).split(',')[0]?.trim().split(/\s+/)[0]
				|| null;
		}

		getLiveOptionsPreviewIndex(){
			if ( ! this.productGallery || ! this.querySelector('.cl-po--input') ) {
				return null;
			}

			const previewSlide = Array.from(this.productGallery.querySelectorAll('.product-gallery-item')).find((slide)=>{
				return !!slide.querySelector('.cl-po--preview-wrapper, .cl-po--preview');
			});

			if ( ! previewSlide ) {
				return null;
			}

			return previewSlide.dataset.index || '0';
		}

		restoreLiveOptionsGalleryPreviews(event){
			const target = event?.target;
			if ( ! target || ! target.closest('.cl-po--input, .cl-po--swatch-item, .cl-po--option') ) {
				return;
			}

			const livePreviewIndex = this.getLiveOptionsPreviewIndex();

			this.querySelectorAll('.product-gallery-item .lazy-image').forEach((figure)=>{
				const previewWrapper = figure.querySelector('.cl-po--preview-wrapper') || figure.querySelector('.cl-po--preview');
				const fallbackImage = figure.querySelector('img[data-thumbnail-preview-fallback="true"]');

				if ( previewWrapper ) {
					previewWrapper.style.display = '';
				}

				if ( fallbackImage ) {
					fallbackImage.remove();
				}
			});

			if ( livePreviewIndex !== null ) {
				if ( ! this.moveProductGalleryToIndex(livePreviewIndex, 'auto') ) {
					const livePreviewSlide = this.productGallery?.querySelector(`.product-gallery-item[data-index="${livePreviewIndex}"]`);
					if ( livePreviewSlide ) {
						window.scrollTo({
							top: livePreviewSlide.offsetTop,
							behavior: 'smooth'
						});
					}
				}
			}
		}

		syncThumbnailPreviewToGallerySlide(index, thumbnail){
			if ( ! this.productGallery || ! thumbnail ) {
				return false;
			}

			const slide = this.productGallery.querySelector(`.product-gallery-item[data-index="${String(index)}"]`);
			const thumbnailImage = thumbnail.querySelector('img');
			if ( ! slide || ! thumbnailImage ) {
				return false;
			}

			const figure = slide.querySelector('.lazy-image');
			if ( ! figure ) {
				return false;
			}

			const thumbnailSrc = thumbnailImage.currentSrc || thumbnailImage.getAttribute('src');
			const expandedThumbnailSrc = this.buildMainPreviewSrc(thumbnailSrc);
			if ( ! expandedThumbnailSrc ) {
				return false;
			}

			const previewWrapper = figure.querySelector('.cl-po--preview-wrapper') || figure.querySelector('.cl-po--preview');
			const slideImage = figure.querySelector('img');
			const thumbnailFilename = this.normalizeGalleryPreviewFilename(thumbnailSrc);
			const slideFilename = this.normalizeGalleryPreviewFilename(this.getComparableGalleryImageSrc(slideImage));
			const needsFallbackPreview = !!previewWrapper || !slideImage || !slideFilename || thumbnailFilename !== slideFilename;

			if ( ! needsFallbackPreview ) {
				return false;
			}

			let targetImage = slideImage;
			if ( ! targetImage || previewWrapper ) {
				targetImage = figure.querySelector('img[data-thumbnail-preview-fallback="true"]');
				if ( ! targetImage ) {
					targetImage = document.createElement('img');
					targetImage.className = 'img';
					targetImage.setAttribute('data-thumbnail-preview-fallback', 'true');
					targetImage.setAttribute('loading', 'eager');
					figure.appendChild(targetImage);
				}
			}

			targetImage.setAttribute('src', expandedThumbnailSrc);
			targetImage.setAttribute('srcset', expandedThumbnailSrc);
			targetImage.setAttribute('alt', thumbnailImage.getAttribute('alt') || slideImage?.getAttribute('alt') || '');
			figure.classList.add('lazyloaded');

			if ( previewWrapper ) {
				previewWrapper.style.display = 'none';
			}

			const zoomTrigger = slide.querySelector('.product-gallery-item__zoom');
			if ( zoomTrigger ) {
				zoomTrigger.setAttribute('data-image', expandedThumbnailSrc);
			}

			return true;
		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			if ( this.initialVariantMediaSyncTimeout ) {
				clearTimeout(this.initialVariantMediaSyncTimeout);
				this.initialVariantMediaSyncTimeout = null;
			}
			this.initialVariantMediaSyncAttempts = 0;

			let variant = e.target.currentVariant;
			if ( variant ) {
				const livePreviewIndex = this.getLiveOptionsPreviewIndex();
				
				// image handling

				if ( livePreviewIndex !== null ) {
					if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
						if ( ! this.moveProductGalleryToIndex(livePreviewIndex, 'smooth') ) {
							this.firstProductGalleryIndex = livePreviewIndex;
						}
					} else {
						let livePreviewSlide = this.productGallery.querySelector(`.product-gallery-item[data-index="${livePreviewIndex}"]`);
						if ( livePreviewSlide ) {
							window.scrollTo({
								top: livePreviewSlide.offsetTop,
								behavior: 'smooth'
							});
						}
					}
				} else if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( ! this.moveProductGalleryToIndex(variantImg.dataset.index, 'smooth') ) {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							window.scrollTo({
								top: variantImg.offsetTop,
								behavior: 'smooth'
							});
						}
					}
				}

			}

			this.refreshShippingAvailability(variant);

		}

		// Both the delivery indicator and the local-pickup widget resolve once,
		// server-side, against whatever variant loaded the page, then never
		// again: the theme prefetches availability for every variant up front
		// (see the /variants/{id}/?section_id=helper-pickup-availability-extended
		// calls at page load) but nothing pointed a later swatch pick at that
		// data. Reported against PR100 and TS010E, but the gap is generic —
		// any product whose variants differ in stock would show it.
		refreshShippingAvailability(variant) {
			if ( ! variant ) {
				return;
			}

			const shippingIndicator = this.querySelector('.shipping-indicator[data-shipping-id]');
			if ( shippingIndicator ) {
				shippingIndicator.setAttribute('data-shipping-id', variant.id);
				shippingIndicator.setAttribute('product-shipping-value', variant.id);
				// Drop the resolved-signature/status classes so the indicator
				// reads as pending rather than confidently (and wrongly) still
				// showing the previous variant's result while this re-runs.
				delete shippingIndicator.dataset.itgShippingResolvedSig;
				shippingIndicator.classList.remove('alert--success', 'alert--error', 'unavailable-delivery');
				shippingIndicator.classList.add('alert--note', 'alert--circle-loading');
				// component-availability-cache.js's own resolver, already exposed
				// globally for exactly this: re-scan and settle every
				// [data-shipping-id] on the page. Its per-variant cache means
				// re-running it costs nothing for variants already fetched.
				if ( typeof window.itgCheckAvailITG === 'function' ) {
					window.itgCheckAvailITG();
				}
			}

			const pickupCompact = this.querySelector('pickup-availability-compact[data-product-page="true"]');
			if ( pickupCompact && typeof pickupCompact.fetchAvailability === 'function' ) {
				pickupCompact.setAttribute('data-variant-id', variant.id);
				pickupCompact.fetchAvailability(variant.id);
			}
		}

	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}